// extracted by mini-css-extract-plugin
export var button = "_im-2";
export var card = "_im-0";
export var closeButtonContainer = "_im-3";
export var iconContainer = "_im-1";